module.exports = __webpack_public_path__ + "img/first-place.f9f51079.png";